module.exports = __webpack_public_path__ + "media/images/countrysquared/sy-a2617e858de18e4bee35f5180c863d26.svg";